export default function () {
  let body = document.querySelector('body')
  let menuTrigger = document.querySelector('.js-menuTrigger')

  if(menuTrigger) {
    menuTrigger.addEventListener('click', ()=>{
      body.classList.toggle('is-active')
    })
  }
}